// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRITICAL FIX: Remove all white borders and spacing */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow: hidden;  /* Prevent scrollbars on body */
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%); /* Default to light mode purple gradient */
}

/* Dark mode body background */
body.dark-mode, html.dark-mode {
  background: #1a1a1a;
}

#root {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;  /* Prevent scrollbars on root */
}

/* THEME SUPPORT: Main app layout with theme classes */
.app {
  display: flex;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;  /* Prevent scrollbars on app */
  transition: background-color 0.3s ease;
}

/* Dark mode styling (default) */
.app.dark-mode {
  background-color: transparent; /* Let body background show through */
}

/* Light mode styling */
.app.light-mode {
  background: transparent; /* Let body background show through */
}

/* ENHANCED: Main content area with chat responsiveness */
.main-content {
  width: calc(100vw - 350px); /* Default with chat open */
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;  /* Prevent scrollbars */
  transition: all 0.3s ease;
}

/* NEW: Main content when chat is closed */
.app.chat-closed .main-content {
  width: 100vw;
}

/* Theme support for main content */
.dark-mode .main-content {
  background-color: transparent; /* Let body background show through */
}

.light-mode .main-content {
  background: transparent; /* Let body background show through */
}

/* âœ… FIXED: Featured video container - absolute positioning, no flow impact */
.featured-video-container {
  position: absolute;  /* âœ… NEW: Remove from document flow */
  top: 3px;  /* âœ… CRITICAL: 3px from top (matches grid gap) */
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  height: 0;  /* âœ… Takes no space */
  overflow: visible;  /* âœ… Content can overflow */
  z-index: 2000;  /* âœ… Above grid */
  transition: all 0.3s ease;
  pointer-events: none;  /* âœ… Don't block clicks */
}

/* âœ… Allow clicks on featured content */
.featured-video-container > * {
  pointer-events: auto;
}

/* Featured video positioning - responsive to chat */
.app.chat-open .featured-video-container {
  width: 100%;
  justify-content: center;
}

.app.chat-closed .featured-video-container {
  width: 100%;
  justify-content: center;
}

/* Featured YouTube player styles */
.featured-youtube-player {
  position: relative;
  width: 854px;
  height: 480px;
  border: 1px solid #8b5cf6;
  border-radius: 3px;
  overflow: hidden;
  background-color: #000;
  cursor: pointer;
}

/* Featured media player styles */
.featured-media-player {
  position: relative;
  width: 854px;
  height: 480px;
  border: 1px solid #8b5cf6;
  border-radius: 3px;
  overflow: hidden;
  background-color: #000;
  cursor: pointer;
}

/* Video grid container */
.video-grid-container {
  flex: 1;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-y: auto;  /* âœ… Container handles scrolling */
  overflow-x: hidden;
}

/* âœ… FIXED: Video grid with 3px top padding */
.video-grid {
  display: grid;
  grid-auto-rows: 180px;
  grid-template-columns: repeat(auto-fill, 310px);
  gap: 3px;
  padding: 10px;  /* âœ… Uniform padding - top padding controlled by inline style */
  justify-content: start;
  align-content: start;
  width: 100%;
  min-height: 100%;  /* âœ… Fill container without overflow */
  transition: background-color 0.3s ease;
}

/* Theme support for video grid */
.dark-mode .video-grid {
  background-color: transparent; /* Let body background show through */
}

.light-mode .video-grid {
  background: transparent; /* Let body background show through */
}

/* Video tile styling with theme support */
.video-tile {
  width: 310px;
  height: 180px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  border: 1px solid #8b5cf6;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
}

.dark-mode .video-tile {
  background-color: #2a2a2a;
}

.light-mode .video-tile {
  background-color: #e8dcc4;
}

.video-tile video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
}

/* Remote video tiles */
.video-tile.remote {
  border: 1px solid #8b5cf6;
  box-sizing: border-box;
}

/* YouTube tile styling */
.youtube-tile {
  width: 310px;
  height: 180px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  background-color: #000;
  border: 1px solid #8b5cf6;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Media tile styling */
.media-tile {
  width: 310px;
  height: 180px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  background-color: #000;
  border: 1px solid #8b5cf6;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Local video special styling */
.video-tile.local {
  border: 1px solid #5b21b6 !important;
  box-sizing: border-box;
}

/* Username overlay with theme support */
.username-overlay {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
  max-width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Video loading states */
.video-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  text-align: center;
  z-index: 5;
}

.dark-mode .video-loading {
  color: #ccc;
}

.light-mode .video-loading {
  color: #666;
}

.video-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ff6b6b;
  font-size: 14px;
  text-align: center;
  z-index: 5;
}

/* Camera button with theme support */
.camera-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  font-weight: 600;
  min-width: auto;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

/* Camera OFF (default green) */
.dark-mode .camera-btn {
  background: rgba(76, 175, 80, 0.9);
  color: white;
}

.light-mode .camera-btn {
  background: rgba(76, 175, 80, 1);
  color: white;
}

/* Camera ON (red) */
.dark-mode .camera-btn.camera-active {
  background: rgba(239, 68, 68, 0.9);
  color: white;
}

.light-mode .camera-btn.camera-active {
  background: rgba(239, 68, 68, 1);
  color: white;
}

.camera-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.camera-btn:disabled {
  background: rgba(128, 128, 128, 0.7);
  cursor: not-allowed;
  transform: none;
}

/* Mute button with theme support */
.mute-btn {
  position: fixed;
  bottom: 20px;
  left: 140px;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  z-index: 1000;
  font-weight: 500;
  min-width: auto;
  background: rgba(139, 92, 246, 0.9);
  color: white;
}

.dark-mode .mute-btn {
  background: rgba(139, 92, 246, 0.9);
  color: white;
}

.light-mode .mute-btn {
  background: rgba(139, 92, 246, 1);
  color: white;
}

.mute-btn:hover {
  background: rgba(139, 92, 246, 1);
  transform: translateY(-2px);
}

/* Connection status with theme support */
.connection-status {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

/* User count display */
.user-count {
  position: fixed;
  top: 10px;
  right: 370px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

/* Responsive adjustments for featured mode */
@media (max-width: 1400px) {
  .featured-video-container {
    padding: 0;  /* âœ… Keep at 0 for all screen sizes */
  }
  
  .featured-youtube-player,
  .featured-media-player {
    width: 100%;
    max-width: 854px;
    height: auto;
    aspect-ratio: 16 / 9;
  }
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .video-grid {
    grid-template-columns: repeat(auto-fill, 310px);
    justify-content: start;
  }
  
  .featured-video-container {
    padding: 0;  /* âœ… Keep at 0 */
  }
}

@media (max-width: 800px) {
  .main-content {
    width: calc(100vw - 300px);
  }
  
  .user-count {
    right: 320px;
  }
  
  .featured-youtube-player,
  .featured-media-player {
    width: 100%;
    max-width: 90vw;
  }
}

@media (max-width: 600px) {
  .video-grid {
    grid-template-columns: repeat(auto-fill, 280px);
    gap: 2px;
    padding: 0 10px 10px 10px;  /* âœ… Keep same pattern */
    padding-top: 3px;
    justify-content: start;
  }
  
  .video-tile,
  .youtube-tile,
  .media-tile {
    width: 280px;
    height: 157px;
  }
  
  .featured-video-container {
    padding: 0;  /* âœ… Keep at 0 */
  }
  
  .featured-youtube-player,
  .featured-media-player {
    width: 100%;
    max-width: 95vw;
  }
}

@keyframes borderFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes borderPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.95;
  }
}

/* Apply to all video tiles when seasonal theme is active */
.app.seasonal-theme .video-tile,
.app.seasonal-theme .youtube-tile,
.app.seasonal-theme .media-tile,
.app.seasonal-theme .stream-tile {
  border: none;
  background: linear-gradient(
    90deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #c026d3,  /* VIVID magenta */
    #ff6b00,  /* VIVID orange */
    #7c3aed   /* VIVID purple */
  );
  background-size: 300% 100%;
  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;
  padding: 2px;  /* REDUCED: Thinner border from 3px to 2px */
  position: relative;
}

/* Create inner content area with proper background */
.app.seasonal-theme .video-tile::before,
.app.seasonal-theme .youtube-tile::before,
.app.seasonal-theme .media-tile::before,
.app.seasonal-theme .stream-tile::before {
  content: '';
  position: absolute;
  inset: 2px;  /* REDUCED: Match padding reduction from 3px to 2px */
  background: var(--bg-secondary);
  border-radius: 2px;
  z-index: 1;
}

/* Ensure video content stays on top */
.app.seasonal-theme .video-tile video,
.app.seasonal-theme .video-tile .content,
.app.seasonal-theme .youtube-tile iframe,
.app.seasonal-theme .youtube-tile .content,
.app.seasonal-theme .media-tile video,
.app.seasonal-theme .media-tile .content,
.app.seasonal-theme .stream-tile video,
.app.seasonal-theme .stream-tile .content {
  position: relative;
  z-index: 2;
}

/* Local webcam gets slightly different color for distinction */
.app.seasonal-theme .video-tile.local {
  background: linear-gradient(
    90deg,
    #6d28d9,  /* DARKER VIVID purple */
    #ea580c,  /* DARKER VIVID orange */
    #a21caf,  /* DARKER VIVID magenta */
    #ea580c,  /* DARKER VIVID orange */
    #6d28d9   /* DARKER VIVID purple */
  );
  background-size: 300% 100%;
}

/* Featured video containers - no animation to avoid distracting from content */
.app.seasonal-theme .featured-youtube-player,
.app.seasonal-theme .featured-media-player,
.app.seasonal-theme .featured-stream-player {
  border: 2px solid #7c3aed;  /* VIVID purple */
  animation: none;
  padding: 0;
}

/* Chat panel seasonal accent */
.app.seasonal-theme .chat-panel {
  border-left: 2px solid;
  border-image: linear-gradient(
    180deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #7c3aed   /* VIVID purple */
  ) 1;
}

/* Admin panel seasonal accent */
.app.seasonal-theme .admin-control-panel {
  border: 1px solid;
  border-image: linear-gradient(
    135deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #7c3aed   /* VIVID purple */
  ) 1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,4DAA4D;EAC5D,gBAAgB,GAAG,+BAA+B;EAClD,6DAA6D,EAAE,0CAA0C;AAC3G;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,gBAAgB,GAAG,+BAA+B;AACpD;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB,GAAG,8BAA8B;EACjD,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,6BAA6B,EAAE,qCAAqC;AACtE;;AAEA,uBAAuB;AACvB;EACE,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA,yDAAyD;AACzD;EACE,0BAA0B,EAAE,2BAA2B;EACvD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB,GAAG,uBAAuB;EAC1C,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,6BAA6B,EAAE,qCAAqC;AACtE;;AAEA;EACE,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB,GAAG,uCAAuC;EAC5D,QAAQ,GAAG,kDAAkD;EAC7D,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,SAAS,GAAG,uBAAuB;EACnC,iBAAiB,GAAG,6BAA6B;EACjD,aAAa,GAAG,mBAAmB;EACnC,yBAAyB;EACzB,oBAAoB,GAAG,2BAA2B;AACpD;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB,GAAG,oCAAoC;EACvD,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;EAC/C,QAAQ;EACR,aAAa,GAAG,iEAAiE;EACjF,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB,GAAG,wCAAwC;EAC3D,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,6BAA6B,EAAE,qCAAqC;AACtE;;AAEA;EACE,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU,GAAG,uCAAuC;EACtD;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;EACtB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,+CAA+C;IAC/C,sBAAsB;EACxB;;EAEA;IACE,UAAU,GAAG,kBAAkB;EACjC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,+CAA+C;IAC/C,QAAQ;IACR,yBAAyB,GAAG,0BAA0B;IACtD,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;;IAGE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU,GAAG,kBAAkB;EACjC;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,2DAA2D;AAC3D;;;;EAIE,YAAY;EACZ;;;;;;;GAOC;EACD,0BAA0B;EAC1B,oFAAoF;EACpF,YAAY,GAAG,4CAA4C;EAC3D,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,UAAU,GAAG,qDAAqD;EAClE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sCAAsC;AACtC;;;;;;;;EAQE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE;;;;;;;GAOC;EACD,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;;;EAGE,yBAAyB,GAAG,iBAAiB;EAC7C,eAAe;EACf,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB;;;;;KAKG;AACL;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB;;;;;KAKG;AACL","sourcesContent":["/* CRITICAL FIX: Remove all white borders and spacing */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  overflow: hidden;  /* Prevent scrollbars on body */\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%); /* Default to light mode purple gradient */\n}\n\n/* Dark mode body background */\nbody.dark-mode, html.dark-mode {\n  background: #1a1a1a;\n}\n\n#root {\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;  /* Prevent scrollbars on root */\n}\n\n/* THEME SUPPORT: Main app layout with theme classes */\n.app {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  overflow: hidden;  /* Prevent scrollbars on app */\n  transition: background-color 0.3s ease;\n}\n\n/* Dark mode styling (default) */\n.app.dark-mode {\n  background-color: transparent; /* Let body background show through */\n}\n\n/* Light mode styling */\n.app.light-mode {\n  background: transparent; /* Let body background show through */\n}\n\n/* ENHANCED: Main content area with chat responsiveness */\n.main-content {\n  width: calc(100vw - 350px); /* Default with chat open */\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  overflow: hidden;  /* Prevent scrollbars */\n  transition: all 0.3s ease;\n}\n\n/* NEW: Main content when chat is closed */\n.app.chat-closed .main-content {\n  width: 100vw;\n}\n\n/* Theme support for main content */\n.dark-mode .main-content {\n  background-color: transparent; /* Let body background show through */\n}\n\n.light-mode .main-content {\n  background: transparent; /* Let body background show through */\n}\n\n/* âœ… FIXED: Featured video container - absolute positioning, no flow impact */\n.featured-video-container {\n  position: absolute;  /* âœ… NEW: Remove from document flow */\n  top: 3px;  /* âœ… CRITICAL: 3px from top (matches grid gap) */\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0;\n  height: 0;  /* âœ… Takes no space */\n  overflow: visible;  /* âœ… Content can overflow */\n  z-index: 2000;  /* âœ… Above grid */\n  transition: all 0.3s ease;\n  pointer-events: none;  /* âœ… Don't block clicks */\n}\n\n/* âœ… Allow clicks on featured content */\n.featured-video-container > * {\n  pointer-events: auto;\n}\n\n/* Featured video positioning - responsive to chat */\n.app.chat-open .featured-video-container {\n  width: 100%;\n  justify-content: center;\n}\n\n.app.chat-closed .featured-video-container {\n  width: 100%;\n  justify-content: center;\n}\n\n/* Featured YouTube player styles */\n.featured-youtube-player {\n  position: relative;\n  width: 854px;\n  height: 480px;\n  border: 1px solid #8b5cf6;\n  border-radius: 3px;\n  overflow: hidden;\n  background-color: #000;\n  cursor: pointer;\n}\n\n/* Featured media player styles */\n.featured-media-player {\n  position: relative;\n  width: 854px;\n  height: 480px;\n  border: 1px solid #8b5cf6;\n  border-radius: 3px;\n  overflow: hidden;\n  background-color: #000;\n  cursor: pointer;\n}\n\n/* Video grid container */\n.video-grid-container {\n  flex: 1;\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  overflow-y: auto;  /* âœ… Container handles scrolling */\n  overflow-x: hidden;\n}\n\n/* âœ… FIXED: Video grid with 3px top padding */\n.video-grid {\n  display: grid;\n  grid-auto-rows: 180px;\n  grid-template-columns: repeat(auto-fill, 310px);\n  gap: 3px;\n  padding: 10px;  /* âœ… Uniform padding - top padding controlled by inline style */\n  justify-content: start;\n  align-content: start;\n  width: 100%;\n  min-height: 100%;  /* âœ… Fill container without overflow */\n  transition: background-color 0.3s ease;\n}\n\n/* Theme support for video grid */\n.dark-mode .video-grid {\n  background-color: transparent; /* Let body background show through */\n}\n\n.light-mode .video-grid {\n  background: transparent; /* Let body background show through */\n}\n\n/* Video tile styling with theme support */\n.video-tile {\n  width: 310px;\n  height: 180px;\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid #8b5cf6;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  transition: background-color 0.3s ease;\n}\n\n.dark-mode .video-tile {\n  background-color: #2a2a2a;\n}\n\n.light-mode .video-tile {\n  background-color: #e8dcc4;\n}\n\n.video-tile video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 3px;\n}\n\n/* Remote video tiles */\n.video-tile.remote {\n  border: 1px solid #8b5cf6;\n  box-sizing: border-box;\n}\n\n/* YouTube tile styling */\n.youtube-tile {\n  width: 310px;\n  height: 180px;\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  background-color: #000;\n  border: 1px solid #8b5cf6;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Media tile styling */\n.media-tile {\n  width: 310px;\n  height: 180px;\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  background-color: #000;\n  border: 1px solid #8b5cf6;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Local video special styling */\n.video-tile.local {\n  border: 1px solid #5b21b6 !important;\n  box-sizing: border-box;\n}\n\n/* Username overlay with theme support */\n.username-overlay {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 10;\n  max-width: calc(100% - 16px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Video loading states */\n.video-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px;\n  text-align: center;\n  z-index: 5;\n}\n\n.dark-mode .video-loading {\n  color: #ccc;\n}\n\n.light-mode .video-loading {\n  color: #666;\n}\n\n.video-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #ff6b6b;\n  font-size: 14px;\n  text-align: center;\n  z-index: 5;\n}\n\n/* Camera button with theme support */\n.camera-btn {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  font-weight: 600;\n  min-width: auto;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n/* Camera OFF (default green) */\n.dark-mode .camera-btn {\n  background: rgba(76, 175, 80, 0.9);\n  color: white;\n}\n\n.light-mode .camera-btn {\n  background: rgba(76, 175, 80, 1);\n  color: white;\n}\n\n/* Camera ON (red) */\n.dark-mode .camera-btn.camera-active {\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n}\n\n.light-mode .camera-btn.camera-active {\n  background: rgba(239, 68, 68, 1);\n  color: white;\n}\n\n.camera-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n}\n\n.camera-btn:disabled {\n  background: rgba(128, 128, 128, 0.7);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Mute button with theme support */\n.mute-btn {\n  position: fixed;\n  bottom: 20px;\n  left: 140px;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  z-index: 1000;\n  font-weight: 500;\n  min-width: auto;\n  background: rgba(139, 92, 246, 0.9);\n  color: white;\n}\n\n.dark-mode .mute-btn {\n  background: rgba(139, 92, 246, 0.9);\n  color: white;\n}\n\n.light-mode .mute-btn {\n  background: rgba(139, 92, 246, 1);\n  color: white;\n}\n\n.mute-btn:hover {\n  background: rgba(139, 92, 246, 1);\n  transform: translateY(-2px);\n}\n\n/* Connection status with theme support */\n.connection-status {\n  position: fixed;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 12px;\n  z-index: 1000;\n  backdrop-filter: blur(10px);\n}\n\n/* User count display */\n.user-count {\n  position: fixed;\n  top: 10px;\n  right: 370px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 12px;\n  z-index: 1000;\n  backdrop-filter: blur(10px);\n}\n\n/* Responsive adjustments for featured mode */\n@media (max-width: 1400px) {\n  .featured-video-container {\n    padding: 0;  /* âœ… Keep at 0 for all screen sizes */\n  }\n  \n  .featured-youtube-player,\n  .featured-media-player {\n    width: 100%;\n    max-width: 854px;\n    height: auto;\n    aspect-ratio: 16 / 9;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .video-grid {\n    grid-template-columns: repeat(auto-fill, 310px);\n    justify-content: start;\n  }\n  \n  .featured-video-container {\n    padding: 0;  /* âœ… Keep at 0 */\n  }\n}\n\n@media (max-width: 800px) {\n  .main-content {\n    width: calc(100vw - 300px);\n  }\n  \n  .user-count {\n    right: 320px;\n  }\n  \n  .featured-youtube-player,\n  .featured-media-player {\n    width: 100%;\n    max-width: 90vw;\n  }\n}\n\n@media (max-width: 600px) {\n  .video-grid {\n    grid-template-columns: repeat(auto-fill, 280px);\n    gap: 2px;\n    padding: 0 10px 10px 10px;  /* âœ… Keep same pattern */\n    padding-top: 3px;\n    justify-content: start;\n  }\n  \n  .video-tile,\n  .youtube-tile,\n  .media-tile {\n    width: 280px;\n    height: 157px;\n  }\n  \n  .featured-video-container {\n    padding: 0;  /* âœ… Keep at 0 */\n  }\n  \n  .featured-youtube-player,\n  .featured-media-player {\n    width: 100%;\n    max-width: 95vw;\n  }\n}\n\n@keyframes borderFlow {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes borderPulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.95;\n  }\n}\n\n/* Apply to all video tiles when seasonal theme is active */\n.app.seasonal-theme .video-tile,\n.app.seasonal-theme .youtube-tile,\n.app.seasonal-theme .media-tile,\n.app.seasonal-theme .stream-tile {\n  border: none;\n  background: linear-gradient(\n    90deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #c026d3,  /* VIVID magenta */\n    #ff6b00,  /* VIVID orange */\n    #7c3aed   /* VIVID purple */\n  );\n  background-size: 300% 100%;\n  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;\n  padding: 2px;  /* REDUCED: Thinner border from 3px to 2px */\n  position: relative;\n}\n\n/* Create inner content area with proper background */\n.app.seasonal-theme .video-tile::before,\n.app.seasonal-theme .youtube-tile::before,\n.app.seasonal-theme .media-tile::before,\n.app.seasonal-theme .stream-tile::before {\n  content: '';\n  position: absolute;\n  inset: 2px;  /* REDUCED: Match padding reduction from 3px to 2px */\n  background: var(--bg-secondary);\n  border-radius: 2px;\n  z-index: 1;\n}\n\n/* Ensure video content stays on top */\n.app.seasonal-theme .video-tile video,\n.app.seasonal-theme .video-tile .content,\n.app.seasonal-theme .youtube-tile iframe,\n.app.seasonal-theme .youtube-tile .content,\n.app.seasonal-theme .media-tile video,\n.app.seasonal-theme .media-tile .content,\n.app.seasonal-theme .stream-tile video,\n.app.seasonal-theme .stream-tile .content {\n  position: relative;\n  z-index: 2;\n}\n\n/* Local webcam gets slightly different color for distinction */\n.app.seasonal-theme .video-tile.local {\n  background: linear-gradient(\n    90deg,\n    #6d28d9,  /* DARKER VIVID purple */\n    #ea580c,  /* DARKER VIVID orange */\n    #a21caf,  /* DARKER VIVID magenta */\n    #ea580c,  /* DARKER VIVID orange */\n    #6d28d9   /* DARKER VIVID purple */\n  );\n  background-size: 300% 100%;\n}\n\n/* Featured video containers - no animation to avoid distracting from content */\n.app.seasonal-theme .featured-youtube-player,\n.app.seasonal-theme .featured-media-player,\n.app.seasonal-theme .featured-stream-player {\n  border: 2px solid #7c3aed;  /* VIVID purple */\n  animation: none;\n  padding: 0;\n}\n\n/* Chat panel seasonal accent */\n.app.seasonal-theme .chat-panel {\n  border-left: 2px solid;\n  border-image: linear-gradient(\n    180deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #7c3aed   /* VIVID purple */\n  ) 1;\n}\n\n/* Admin panel seasonal accent */\n.app.seasonal-theme .admin-control-panel {\n  border: 1px solid;\n  border-image: linear-gradient(\n    135deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #7c3aed   /* VIVID purple */\n  ) 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
